import { z } from 'zod';

export const standalonePrinterSchema = z.object({
  imei: z.string().describe('IMEI number of the printer'),
  isOnlineNow: z.boolean().default(false),
  restaurantId: z.string().nullable().default(null),
  serialNumber: z.string().nullable().default(null),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type StandalonePrinter = z.output<typeof standalonePrinterSchema>;

/** Strict schema */
export const standalonePrinterStrictSchema = standalonePrinterSchema.extend({
  imei: z.string().trim().min(15).max(15),
  serialNumber: z.string().trim().min(2).nullable(),
});

/** Convex schema */
export const standalonePrinterCvxSchema = standalonePrinterSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type StandalonePrinterCvx = z.output<typeof standalonePrinterCvxSchema>;
